<template>
  <div class="container">
    <h3>Mac版Anymo会提示无法打开</h3>
    <p><img src='/static/image/max-1.png' width="150px"/></p>
    <p>解决方法如下：</p>
    <p>1.点击电脑左上角苹果图标，选择打开系统设置：</p>
    <p><img src='/static/image/max-2.png' width="100px"/></p>
    <p>2.找到 安全性与隐私，点击【仍要打开】即可</p>
    <p>较新版系统界面</p>
    <p><img src='/static/image/max-4.png' width="400px"/></p>
    <p>较旧版系统界面</p>
    <p><img src='/static/image/max-3.png' width="400px"/></p>
    <div class="h-200"></div>
  </div>
</template>

<script>


export default {
  name: "Max",
  data() {
    return {}
  },
  mounted() {

  }
}
</script>

<style scoped>
.container {
  width: 85%;
  max-width: 600px;
  margin: 30px auto 0;
  padding: 2% 5%;
  border-radius: 10px
}

ul {
  padding-left: 20px;
}

ul li {
  line-height: 2.3
}

a {
  color: #20a53a
}
</style>
